import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AccessDeniedComponent } from './access-denied/access-denied.component';
import { FormulaSearchComponent } from './formula-search/formula-search.component';
import { FormulasColorComponent } from './formulas-color/formulas-color.component';
import { AuthGuard } from './guard/auth.guard';
import { EnviarNotificacionComponent } from './enviar-notificacion/enviar-notificacion.component';
import { NotificacionListComponent } from './notificacion-list/notificacion-list.component';
import { PictogramaDetailComponent } from './admin/pictograma-detail/pictograma-detail.component';

const usersModule = () => import('./users/users.module').then(x => x.UsersModule);
const adminModule = () => import('./admin/admin.module').then(m => m.AdminModule)
const reportesModule = () => import('./reportes/reportes.module').then(m => m.ReportesModule)
const nuevaFormulaModule = () => import('./nueva-formula/nueva-formula.module').then(m => m.NuevaFormulaModule)


const routes: Routes = [
  // { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
  { path: '', component: FormulaSearchComponent, canActivate: [AuthGuard] },
  { path: 'formulacolor/:idsistema/:idformula/:idcolor', component: FormulasColorComponent, canActivate: [AuthGuard] },
  { path: 'notificar', component: EnviarNotificacionComponent, canActivate: [AuthGuard] },
  { path: 'notificaciones', component: NotificacionListComponent, canActivate: [AuthGuard] },

  // ADMIN, REGION Y CLIENTES
  { path: 'users', loadChildren: usersModule },
  { path: 'admin', loadChildren: adminModule },
  { path: 'reportes', loadChildren: reportesModule },
  { path: 'nuevaformula', loadChildren: nuevaFormulaModule },
  { path: "accessdenied", component: AccessDeniedComponent },
  // otherwise redirect to home
  { path: '**', redirectTo: '' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { enableTracing: false })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
